import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="draft-clear"
// クリック時にlocalStorageの下書きをクリアする
export default class extends Controller {
  static values = { key: String }

  clear() {
    if (this.keyValue) {
      localStorage.removeItem(this.keyValue)
    }
  }
}
